import { HierarchyType } from 'legacy/lut/classes/models/partner360/HierarchyType'

import { ICountry } from 'core/classes/models/IReference'

import { IPartnerSearchPartnerFilters } from '../../../models/search'
import { ILegalAddressPartner } from '../models/partner/legalAddressPartner'
import { IPartnerSearchCommon } from '../models/partner/partnerSearchCommon'
import { IPhysicalAddressPartner } from '../models/partner/physicalAddressPartner'

interface IGetPartnerDataParameters {
  partnerFilters: IPartnerSearchPartnerFilters
  type: 'partners' | 'contacts'
  isBranchVisible: boolean
  countries: ICountry[]
}

export const getPartnerData = ({
  partnerFilters,
  isBranchVisible,
  countries,
  type,
}: IGetPartnerDataParameters): ILegalAddressPartner | IPhysicalAddressPartner => {
  const country = countries.find((it) =>
    partnerFilters.isLegal
      ? it.name === partnerFilters.legalCountry
      : it.name === partnerFilters.country
  )
  const countryISO = country ? country.value : undefined
  const common: IPartnerSearchCommon = {
    ppid: partnerFilters.partnerId,
    taxID: partnerFilters.taxId,
    locationID: partnerFilters.locationId,
    storeNumber: partnerFilters.storeNumber,
    url: partnerFilters.url,
    agreementNumber: partnerFilters.agreementNumber,
  }

  if (type === 'partners' && !isBranchVisible) {
    common.hierarchy = [HierarchyType.HEADQUARTERS]
  }

  if (partnerFilters.isLegal) {
    return {
      ...common,
      addressLegal: {
        companyName: partnerFilters.companyLegalName,
        countryISO,
        state: partnerFilters.legalState,
        city: partnerFilters.legalCity,
        zip: partnerFilters.legalZipCode,
        address: partnerFilters.legalAddress,
      },
    }
  }

  return {
    ...common,
    addressPhysical: {
      companyName: partnerFilters.communicationName,
      countryISO,
      state: partnerFilters.state,
      city: partnerFilters.city,
      zip: partnerFilters.zipCode,
      address: partnerFilters.address,
    },
  }
}
